var React = require('react');

function OpenHome (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.676 9.176l.775-3.875 1.494 7.47a.76.76 0 0 1-1.49.298l-.779-3.893zM4.88 11.4l-.334 1.669a.76.76 0 1 1-1.49-.298l1.52-7.6a.76.76 0 0 1 .76-.611h8.512l-1.702 8.509a.76.76 0 0 1-1.49-.298l.274-1.371h-6.05z","fill":"currentColor"}));
}

OpenHome.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = OpenHome;

OpenHome.default = OpenHome;
